import { Directive, Input, OnInit } from "@angular/core";
import { SelectButton } from "primeng-v17/selectbutton";

@Directive({ selector: "p-selectButton[readonly]", standalone: true })
export class SelectButtonReadonlyDirective implements OnInit {
  @Input() readonly = false;

  private onOptionSelectSource: SelectButton["onOptionSelect"];
  private onKeyDownSource: SelectButton["onKeyDown"];

  constructor(private readonly selectButton: SelectButton) {}

  ngOnInit(): void {
    // Store the original methods
    this.onOptionSelectSource = this.selectButton.onOptionSelect;
    this.onKeyDownSource = this.selectButton.onKeyDown;

    // Override the onOptionSelect method
    this.selectButton.onOptionSelect = (event: any, option: any, index: any): void => {
      // If readonly is set, prevent the selection
      if (this.readonly) {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        return;
      }
      // Otherwise call the original method
      return this.onOptionSelectSource.call(this.selectButton, event, option, index);
    };

    // Override the onKeyDown method
    this.selectButton.onKeyDown = (event: any, option: any, index: any): void => {
      // If readonly is set, prevent keyboard interaction
      if (this.readonly) {
        event?.preventDefault?.();
        return;
      }
      // Otherwise call the original method
      return this.onKeyDownSource.call(this.selectButton, event, option, index);
    };
  }
}
